module.exports = __webpack_public_path__ + "img/lidingtiaoyuan.0d7a5e43.png";